import { styled } from '@mui/material/styles';
import { useState } from 'react';
import DashboardSidebar from '../DashboardSidebar/DashboardSidebar';

/**
 * App bar mobile height
 */
const APP_BAR_MOBILE = 64;
/**
 * App bar desktop height
 */
const APP_BAR_DESKTOP = 160;

/**
 * Root style.
 */
const RootStyle = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden'
});

/**
 * Main content style.
 */
const MainStyle = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: 0,
  paddingBottom: theme.spacing(0),
  [theme.breakpoints.up('lg')]: {
    paddingTop: 0,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(0)
  }
}));

interface DashboardLayoutProps {
  children: React.ReactNode;
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  const [open, setOpen] = useState(false);
  return (
    <RootStyle>
      {/* Side dashboard navigation bar */}
      {/* <DashboardSidebar isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} /> */}

      {/* Dashboard content */}
      <MainStyle>{children}</MainStyle>
    </RootStyle>
  );
};

export default DashboardLayout;
